export default __webpack_public_path__ + "static/media/ravenous-logo.adcedb9f.svg";